export default __webpack_public_path__ + "static/media/TopicsBig.b9367486.mp4";